import { IPermissoes } from "../interfaces/IPermissoes";
import api from "./Api";
import Swal from 'sweetalert2';

class PermissoesService {

  async obterTodos(funcaoSucesso?: (data: IPermissoes[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IPermissoes[]>('Permissao');

      funcaoSucesso && funcaoSucesso(result);
  
      textoPopupSucesso && Swal.fire({
          text: textoPopupSucesso,
          timer: 3000,
          icon: 'success',
          showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });
  
      return false;
    }
  }
  
  async obterPorId(id: number, funcaoSucesso?: (data: IPermissoes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IPermissoes>(`Permissao/${id}`);

      funcaoSucesso && funcaoSucesso(result);
  
      textoPopupSucesso && Swal.fire({
          text: textoPopupSucesso,
          timer: 3000,
          icon: 'success',
          showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });
  
      return false;
    }
  }

  async criar(parametro: IPermissoes, funcaoSucesso?: (data: IPermissoes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post('Permissao', parametro);

      funcaoSucesso && funcaoSucesso(result);
  
      textoPopupSucesso && Swal.fire({
          text: textoPopupSucesso,
          timer: 3000,
          icon: 'success',
          showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });
  
      return false;
    }
  }

  async atualizar(parametro: IPermissoes, funcaoSucesso?: (data: IPermissoes) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.put(`Permissao/${parametro.id}`, parametro);

      funcaoSucesso && funcaoSucesso(result);
  
      textoPopupSucesso && Swal.fire({
          text: textoPopupSucesso,
          timer: 3000,
          icon: 'success',
          showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });
  
      return false;
    }
  }

  async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.delete(`Permissao/${id}`);

      funcaoSucesso && funcaoSucesso();
  
      textoPopupSucesso && Swal.fire({
          text: textoPopupSucesso,
          timer: 3000,
          icon: 'success',
          showConfirmButton: false
      });
      
      return true;
    } catch (error: any) {
      Swal.fire({
          text: error.message,
          timer: 4000,
          icon: 'error',
          showConfirmButton: false
      });
  
      return false;
    }
  }
}

export default new PermissoesService();